import appConfig from '@nerdwallet/app-config';
import { HOMEPAGE as analyticsBase } from '../analytics-constants';

export default {
  title: "Our Nerds' smartest\n products for 2024",
  titleEnd: '',
  subtitle: `Get on the fast track to smart financial decision-making with our annual list of top financial products — from credit cards to personal loans and beyond.`,
  backgroundColor: '#008254',
  backgroundColorMobile: '#DDFA88',
  ctaButtonText: 'shop the list',
  ctaLinkUrl: '/l/awards',
  titlePreColor: '#FFFFFF',
  titleEndColor: '#e2ff39',
  visualDesktopBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/best-of-awards-2024-hp-campaign_wide.png`,
  visualMobileBackgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/best-of-awards-2024-hp-campaign_mobile.png`,
  visualBackgroundImageAlt: 'NerdWallet Best-Of Awards 2024',
  elementImpressionEntityName: analyticsBase.entity_names.campaign, // used for the Impression of the component
  elementImpressionSectionName: analyticsBase.section_name,
  trkQueryParam: analyticsBase.entity_names.campaign, // used to append to the URL when the button is clicked
};
